import React, { useState, useEffect, useMemo } from 'react';
import { Container, Navbar, Nav, NavDropdown, Form, Row, Col, Popover, Button, OverlayTrigger } from 'react-bootstrap';
import { pega_ranking_soma_bolsa, pega_matriz_curricular } from "../../services/api";
import { ConverteSerie } from "./modulo"; // <-- NOVO IMPORT
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Registrando os componentes necessários do Chart.js
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const DesempenhoPorFaixa = () => {
    const [data2, setData2] = useState([]);
    const [matrizCurricular, setMatrizCurricular] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCycle, setSelectedCycle] = useState('d2');
    const [selectedSerie, setSelectedSerie] = useState('Todas'); // <-- NOVO ESTADO DO FILTRO

    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await pega_ranking_soma_bolsa();
                console.log("Dados recebidos de pega_ranking_soma_bolsa:", response);
                const response2 = await pega_matriz_curricular();
                setData2(response);
                setMatrizCurricular(response2);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // --- NOVO: Extração das Séries Únicas para o Select ---
    const seriesList = useMemo(() => {
        if (!data2.length) return [];
        const uniqueSeriesSet = new Set();

        data2.forEach(item => {
            if (item.serie) {
                // Presume-se que ConverteSerie receba a string de turma ou sua abreviação
                const serieConvertida = ConverteSerie(item.serie);
                if (serieConvertida) {
                    uniqueSeriesSet.add(serieConvertida);
                }
            }
        });

        return Array.from(uniqueSeriesSet).sort();
    }, [data2]);

    const processedData = useMemo(() => {
        if (!data2.length || !matrizCurricular.length) return [];

        return data2
            .filter(item => {
                // --- NOVO: Lógica de Filtro por Série ---
                if (selectedSerie === 'Todas') return true;
                if (!item.serie) return false;
                return ConverteSerie(item.serie) === selectedSerie;
            })
            .map(item => {
                let _ser = item.tur.substring(2, 3);
                let _gra = item.tur.substring(0, 1);
                let divisor = matrizCurricular.filter(mc => mc.ser === _ser && mc.gra === _gra && mc.sts === true && (parseInt(mc.dis) < 340 || parseInt(mc.dis) > 357)).length;

                if (divisor === 0) {
                    return { unidade: unidades[parseInt(item.unidade)], d1: 0, d2: 0, d3: 0, d4: 0, d_anual: 0 };
                }

                const d1 = parseFloat(((parseFloat(item.c1) / (divisor * 25)) * 100).toFixed(2));
                const d2 = parseFloat(((parseFloat(item.c2) / (divisor * 25)) * 100).toFixed(2));
                const d3 = parseFloat(((parseFloat(item.c3) / (divisor * 25)) * 100).toFixed(2));
                const d4 = parseFloat(((parseFloat(item.c4) / (divisor * 25)) * 100).toFixed(2));
                const d_anual = parseFloat(((parseFloat(item.c1) + parseFloat(item.c2) + parseFloat(item.c3) + parseFloat(item.c4)) / (divisor * 100) * 100).toFixed(2));

                return { unidade: unidades[parseInt(item.unidade)], d1, d2, d3, d4, d_anual };
            });
    }, [data2, matrizCurricular, selectedSerie]); // <-- Incluindo selectedSerie na dependência

    const summaryData = useMemo(() => {
        if (!processedData.length) return {};
        const ranges = {
            '0-25': (v) => v >= 0 && v < 25, '25-50': (v) => v >= 25 && v < 50,
            '50-70': (v) => v >= 50 && v < 70, '70-90': (v) => v >= 70 && v < 90,
            '90-100': (v) => v >= 90 && v <= 100,
        };
        const cycles = ['d1', 'd2', 'd3', 'd4', 'd_anual'];
        const summary = {};

        processedData.forEach(item => {
            if (!summary[item.unidade]) {
                summary[item.unidade] = {};
                cycles.forEach(cycle => {
                    summary[item.unidade][cycle] = { '0-25': 0, '25-50': 0, '50-70': 0, '70-90': 0, '90-100': 0 };
                });
            }
            cycles.forEach(cycle => {
                for (const range in ranges) {
                    if (ranges[range](item[cycle])) {
                        summary[item.unidade][cycle][range]++;
                    }
                }
            });
        });
        return summary;
    }, [processedData]);

    const chartDataAbsolute = useMemo(() => {
        const labels = Object.keys(summaryData).sort();
        const ranges = ['0-25', '25-50', '50-70', '70-90', '90-100'];
        const colors = ['#ff4d4f', '#ffc53d', '#ffec3d', '#52c41a', '#1890ff'];
        return {
            labels,
            datasets: ranges.map((range, index) => ({
                label: `${range}%`,
                data: labels.map(unidade => summaryData[unidade]?.[selectedCycle]?.[range] || 0),
                backgroundColor: colors[index],
            })),
        };
    }, [summaryData, selectedCycle]);

    const chartDataPercentage = useMemo(() => {
        const labels = Object.keys(summaryData).sort();
        const ranges = ['0-25', '25-50', '50-70', '70-90', '90-100'];
        const colors = ['#ff4d4f', '#ffc53d', '#ffec3d', '#52c41a', '#1890ff'];

        const percentageData = labels.map(unidade => {
            const cycleData = summaryData[unidade]?.[selectedCycle];
            if (!cycleData) return ranges.map(() => 0);

            const total = ranges.reduce((sum, range) => sum + cycleData[range], 0);
            if (total === 0) return ranges.map(() => 0);

            return ranges.map(range => (cycleData[range] / total) * 100);
        });

        return {
            labels,
            datasets: ranges.map((range, index) => ({
                label: `${range}%`,
                data: percentageData.map(data => data[index]),
                backgroundColor: colors[index],
            })),
        };
    }, [summaryData, selectedCycle]);

    const chartOptionsAbsolute = {
        plugins: {
            title: { display: true, text: `Distribuição por Quantidade de Alunos`, font: { size: 16 } },
            legend: { position: 'top' },
        },
        responsive: true, maintainAspectRatio: false,
        scales: {
            x: { stacked: true, title: { display: true, text: 'Unidades' } },
            y: { stacked: true, title: { display: true, text: 'Quantidade de Alunos' } },
        },
    };

    const chartOptionsPercentage = {
        plugins: {
            title: { display: true, text: 'Distribuição Percentual de Alunos por Faixa', font: { size: 16 } },
            legend: { position: 'top' },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += context.parsed.y.toFixed(2) + '%';
                        }
                        return label;
                    }
                }
            }
        },
        responsive: true, maintainAspectRatio: false,
        scales: {
            x: { stacked: true, title: { display: true, text: 'Unidades' } },
            y: { stacked: true, min: 0, max: 100, title: { display: true, text: 'Percentual de Alunos (%)' } },
        },
    };

    const infoPopover = (
        <Popover id="popover-basic">
            <Popover.Header as="h3">O que é Desempenho?</Popover.Header>
            <Popover.Body>
                <p>O <strong>Desempenho (D)</strong> mede o percentual de aproveitamento do aluno em relação à pontuação máxima possível em um ciclo ou no ano.</p>
                <p>A fórmula para o desempenho de um ciclo é:</p>
                <p><em>D = (Total de Pontos Obtidos / Pontuação Máxima Possível) × 100</em></p>
                <p>Onde a <strong>Pontuação Máxima Possível</strong> é calculada como <em>25 pontos multiplicados pelo número de disciplinas cursadas</em>.</p>
                <p>Para o desempenho anual, somam-se os pontos obtidos em todos os ciclos e divide-se pela pontuação máxima anual (que é 100 pontos multiplicados pelo número de disciplinas).</p>
                <p>O desempenho é expresso em porcentagem, variando de 0% a 100%.</p>
                <br />
                <strong>Exemplo por Ciclo:</strong>
                <p>Se um aluno cursa <strong>3 disciplinas</strong>, o máximo de pontos por ciclo é 3 x 25 = 75. Se ele obteve <strong>50 pontos</strong>, seu desempenho foi de (50 / 75) x 100 = 66,66%.</p>
                <strong>Exemplo Anual:</strong>
                <p>Considerando o mesmo aluno, se suas notas nos 4 ciclos foram 50, 60, 70 e 80, o somatório anual é <strong>260</strong>. O máximo anual seria 75 x 4 = 300 pontos. Seu desempenho anual foi de (260 / 300) x 100 = 86,66%.</p>
            </Popover.Body>
        </Popover>
    );

    return (
        <div className="Evasão">
            <Container fluid className="mt-4">
                <h1 className="text-center mb-2">Análise de Desempenho por Unidade</h1>

                <Row className="justify-content-center mb-4">
                    <Col md={5} lg={4}>
                        <Form.Group controlId="cycleSelector">
                            <div className="d-flex align-items-center">
                                <Form.Label className="fw-bold mb-0 me-2">Selecione o Ciclo para Visualização</Form.Label>
                                <OverlayTrigger trigger="click" placement="right" overlay={infoPopover} rootClose>
                                    <Button variant="outline-info" size="sm" className="rounded-circle p-0" style={{ width: '24px', height: '24px' }}>
                                        ?
                                    </Button>
                                </OverlayTrigger>
                            </div>
                            <Form.Select value={selectedCycle} onChange={e => setSelectedCycle(e.target.value)}>
                                <option value="d1">Ciclo 1</option>
                                <option value="d2">Ciclo 2</option>
                                <option value="d3">Ciclo 3</option>
                                <option value="d4">Ciclo 4</option>
                                <option value="d_anual">Desempenho Anual</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    {/* --- NOVO: Seletor de Séries na Interface --- */}
                    <Col md={5} lg={4}>
                        <Form.Group controlId="serieSelector">
                            <Form.Label className="fw-bold mb-0 d-block" style={{ height: '24px' }}>Selecione a Série</Form.Label>
                            <Form.Select value={selectedSerie} onChange={e => setSelectedSerie(e.target.value)}>
                                <option value="Todas">Todas as Séries</option>
                                {seriesList.map((serie, index) => (
                                    <option key={index} value={serie}>{serie}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                {loading ? (
                    <div className="text-center">Carregando...</div>
                ) : (
                    <Row>
                        <Col xl={6} className="mb-5">
                            <div style={{ height: '500px', position: 'relative' }}>
                                <Bar options={chartOptionsAbsolute} data={chartDataAbsolute} />
                            </div>
                        </Col>
                        <Col xl={6}>
                            <div style={{ height: '500px', position: 'relative' }}>
                                <Bar options={chartOptionsPercentage} data={chartDataPercentage} />
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    );
};

export default DesempenhoPorFaixa;